import {Tab, Spinner, SpinnerSize} from "@blueprintjs/core";
import { useApiEffect } from "nsitools-react";
import * as React from "react";
import { useHistory, useParams } from "react-router";

import { CountryApi } from "../../../../api";
import { ERoutes } from "../../../../ERoutes";
import { BackButton, PageBase, ProtectedTabs } from "../../../../components";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { CountryDetailPage } from "./CountryDetailPage";
import { TitleListPage } from "./title/TitleListPage";

export interface ICountryItemPageProps {}

export const CountryItemPage: React.FunctionComponent<ICountryItemPageProps> = () => {
  const { t } = useTl();
  const { id, tab, state = "edit" } = useParams<{ id: string; tab: string; state: string }>();
  const countryId = React.useMemo(() => +id, [id]);
  const history = useHistory();
  const api = useApiService(CountryApi);
  const [displayName, loading] = useApiEffect(() => api.getDisplayName(countryId), [countryId]);

  return (
    <PageBase
      breadCrumbs={[
        { text: t(ETLCodes.Country), route: ERoutes.country },
        { text: countryId > 0 ? loading ? <Spinner size={SpinnerSize.SMALL} /> : displayName : t(ETLCodes.New) },
      ]}
    >
      <ProtectedTabs
        id="TabsCountry"
        onChange={(newTabId) => history.push(`${ERoutes.country}/${id}/${newTabId}/${state}`)}
        selectedTabId={tab}
        renderActiveTabPanelOnly
      >
        <BackButton backRoute={ERoutes.country} />
        <Tab
          id="detail"
          title={t(ETLCodes.Detail)}
          panel={<CountryDetailPage countryId={countryId} edit={state === "edit"} />}
        />
        <Tab
          id="titles"
          title={t(ETLCodes.Titles)}
          panel={<TitleListPage countryId={countryId} />}
          disabled={countryId <= 0}
        />
      </ProtectedTabs>
    </PageBase>
  );
};
